import React from 'react';
import { Button } from '../Button';
import { Badge } from '../Badge';
import { LeadClockHeroSlot } from '../leadClock/LeadClock';
export function Hero() {
  return <section className="w-full border-b border-gray-200 bg-white px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24" data-id="element-87">
      <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center" data-id="element-88">
        {/* Left column */}
        <div className="flex flex-col gap-6 sm:gap-8" data-id="element-89">
          <div data-id="element-90">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-navy-500 text-white uppercase tracking-[0.15em] text-[11px] font-semibold" data-id="element-91">
              AI-Powered Lead Response
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-gray-900 tracking-tight" data-id="element-92">
            <span className="block" data-id="element-93">
              <span className="text-orange-brand-500" data-id="element-94">78%</span> of deals go to
            </span>
            <span className="block" data-id="element-95">whoever responds first.</span>
          </h1>

          <p className="text-base text-gray-600 max-w-xl leading-relaxed" data-id="element-96">
            speed-to-lead.ai automatically engages every inbound lead via text
            and email the moment they arrive — so you never miss the
            first-response window.
          </p>

          {/* Metric stats — inline row on mobile, card grid on sm+ */}
          <div className="hidden sm:grid grid-cols-3 gap-2 max-w-md" data-id="element-97">
            <div className="border border-navy-500/20 bg-navy-50 px-3 py-2 rounded-md text-center" data-id="element-98">
              <div className="text-sm font-semibold text-navy-500" data-id="element-99">
                &lt; 30s
              </div>
              <div className="text-xs text-gray-500 mt-0.5" data-id="element-100">response time</div>
            </div>
            <div className="border border-navy-500/20 bg-navy-50 px-3 py-2 rounded-md text-center" data-id="element-101">
              <div className="text-sm font-semibold text-navy-500" data-id="element-102">391%</div>
              <div className="text-xs text-gray-500 mt-0.5" data-id="element-103">
                more conversions
              </div>
            </div>
            <div className="border border-navy-500/20 bg-navy-50 px-3 py-2 rounded-md text-center" data-id="element-104">
              <div className="text-sm font-semibold text-navy-500" data-id="element-105">24/7</div>
              <div className="text-xs text-gray-500 mt-0.5" data-id="element-106">availability</div>
            </div>
          </div>

          {/* Mobile — inline stat row with dividers */}
          <div className="sm:hidden flex items-stretch border-y border-gray-200 divide-x divide-gray-200" data-id="element-107">
            <div className="flex-1 py-3 flex flex-col items-center text-center gap-0.5" data-id="element-108">
              <div className="text-lg font-semibold text-gray-900 leading-none" data-id="element-109">
                &lt; 30s
              </div>
              <div className="text-[11px] text-gray-500 leading-tight" data-id="element-110">
                response time
              </div>
            </div>
            <div className="flex-1 py-3 flex flex-col items-center text-center gap-0.5" data-id="element-111">
              <div className="text-lg font-semibold text-gray-900 leading-none" data-id="element-112">
                391%
              </div>
              <div className="text-[11px] text-gray-500 leading-tight" data-id="element-113">
                more conversions
              </div>
            </div>
            <div className="flex-1 py-3 flex flex-col items-center text-center gap-0.5" data-id="element-114">
              <div className="text-lg font-semibold text-gray-900 leading-none" data-id="element-115">
                24/7
              </div>
              <div className="text-[11px] text-gray-500 leading-tight" data-id="element-116">
                availability
              </div>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3" data-id="element-117">
            <Button variant="primary" size="large" rightIcon={<span aria-hidden data-id="element-119">→</span>} className="!bg-navy-500 !border-navy-500 hover:!bg-navy-800 hover:!border-navy-800" data-id="element-118">
              Book a Demo
            </Button>
            <Button variant="secondary" size="large" data-id="element-120">
              See It Work
            </Button>
          </div>

          <p className="text-xs text-gray-500" data-id="element-121">
            Works with HubSpot, Salesforce, Twilio &amp; 40+ tools
          </p>
        </div>

        {/* Right column — live lead clock */}
        <LeadClockHeroSlot data-id="element-122" />
      </div>
    </section>;
}